<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Segments & Consumer habits
            </v-row>
            <v-divider />
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col cols="4"></v-col>
                <v-divider vertical></v-divider>
                <v-col cols="2" class="tabCell text-center"> Purchasing habits</v-col>
                <v-divider vertical></v-divider>
                <v-col cols="2" class="tabCell text-center"> Purchasing preferences</v-col>
                <v-divider vertical></v-divider>
                <v-col cols="3" class="tabCell text-center">Brand importance</v-col>
                <v-divider vertical></v-divider>
                <v-col cols="1"></v-col>
            </v-row>
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" cols="1" class="tabCell" :class="item.style">
                    {{ item.title }}
                </v-col>
                <v-divider vertical></v-divider>
                <v-col v-for="i in habits" :key="i" class="tabCell text-center" cols="1">
                    {{ i }}
                </v-col>
                <v-divider vertical></v-divider>
                <v-col v-for="i in preferences" :key="i" class="tabCell text-center" cols="1">
                    {{ i }}
                </v-col>
                <v-divider vertical></v-divider>
                <v-col v-for="i in brand_importance" :key="i" cols="1" class="tabCell text-center">
                    {{ i }}
                </v-col>
                <v-divider vertical></v-divider>
                <v-col class="tabCell text-center" cols="1">
                    Actions
                </v-col>
            </v-row>
            <div v-if="market_segments.length">
                <!--segments tab-->
                <v-row v-for="segment in market_segments" :key="segment.id" no-gutters>
                    <v-col cols="1" class="tabCell text-truncate text-left">{{ segment.segment?.name }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ localeNumber(segment.segment?.peak_size) }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ segment.max_price }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ segment.min_price }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ segment.lowest_price }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ segment.best_quality }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ segment.on_line }}</v-col>
                    <v-col cols="1" class="tabCell text-center">{{ segment.off_line }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.brand_high }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.brand_somehow }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.brand_not }}</v-col>
                    <v-col cols="1" class="tabCell text-center">
                        <edit-market-segment :segment="segment"></edit-market-segment>
                        <delete-segment :segment="segment" />
                    </v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-4" justify="center">
                there are no segments yet
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>

import EditMarketSegment from '../../../components/admin/segments/editMarketSegment.vue'
import DeleteSegment from '../../../components/admin/segments/deleteSegment.vue'
import Loader from '../../../layouts/Loader.vue'

export default {
    data() {
        return {

            headers: [
                { title: 'Segment', style: 'text-left' },
                { title: 'Market size', style: 'text-center' },
                { title: 'Max price', style: 'text-center' },
                { title: 'Min price', style: 'text-center' },
            ],
            habits: ['lowest price', 'best quality'],
            preferences: ['on-line', 'off-line'],
            brand_importance: ['high', 'somehow', 'not important'],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        market_segments() {
            return this.$store.getters.market_segments;
        }
    },
    methods: {
        localeNumber(num) {
            if (this.locale == 'ro-RO') {
                return num.toLocaleString('en-US')
            }
            return num.toLocaleString(this.locale)
        },

    },
    components: {
        EditMarketSegment,
        DeleteSegment,
        Loader
    }/* ,
    async mounted() {
        if(this.segments.length < 1) {
            const obj = {
                game_id: this.set.value,
                round: 0
            }
            await this.$store.dispatch('fetchSegments', obj);
        }
    } */
}
</script>
